"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUSINESS = exports.CONSUMER = void 0; // Types for the `debtsPrimarily` field of Case

var CONSUMER = 'consumer';
exports.CONSUMER = CONSUMER;
var BUSINESS = 'business';
exports.BUSINESS = BUSINESS;